export const langData = [
  {
    id: 1,
    code: "uz",
    title: "Uz",
  },
  {
    id: 2,
    code: "kr",
    title: "Уз",
  },
  {
    id: 3,
    code: "ru",
    title: "Ru",
  },
  {
    id: 4,
    code: "en",
    title: "En",
  },
];
